import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RemoteConfigService, remoteConfigStore } from '@puzzlemania/remote-config';
import { GameCard } from './GameCard';
function makeAppRc() {
    return new RemoteConfigService();
}
const PLACEHOLDER_GAMES = [
    {
        gameId: 'blockjam',
        nameKey: 'game.blockjam.name',
        descKey: 'game.blockjam.desc',
        brandColor: '#ff6600',
        state: 'available',
    },
    {
        gameId: 'watersort',
        nameKey: 'game.watersort.name',
        descKey: 'game.watersort.desc',
        brandColor: '#0088ff',
        state: 'available',
    },
    {
        gameId: 'reference-plugin',
        nameKey: 'game.reference.name',
        descKey: 'game.reference.desc',
        brandColor: 'var(--color-muted)',
        state: 'coming-soon',
        isComingSoon: true,
    },
];
export function GameGrid({ saveDataMap, rc: injectedRc } = {}) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const rcRef = useRef(injectedRc ?? makeAppRc());
    // Subscribe to the reactive remote-config store so a live RC refresh
    // (RemoteConfigService.fetch()) re-renders the grid — a flag flipped at
    // runtime makes the corresponding tile appear/disappear without a page
    // reload. The injected/DEV RemoteConfigService remains the synchronous
    // source of truth until a fetch populates the store with a pushed value.
    const liveFlags = remoteConfigStore((s) => s.flags);
    const visibleGames = PLACEHOLDER_GAMES.filter((g) => {
        if (g.isComingSoon)
            return false;
        const key = `${g.gameId}_enabled`;
        const live = liveFlags[key];
        return live ?? rcRef.current.get(key, true);
    });
    return (_jsx("div", { className: "game-grid", role: "list", "aria-label": t('game.section.title'), children: visibleGames.map((game) => (_jsx("div", { role: "listitem", children: _jsx(GameCard, { gameId: game.gameId, displayName: t(game.nameKey), shortDescription: t(game.descKey), brandColor: game.brandColor, state: game.state, ...(game.lockCondition ? { lockCondition: game.lockCondition } : {}), ...(saveDataMap?.[game.gameId] ? { showContinue: true } : {}), onTap: () => navigate(`/game/${game.gameId}`) }) }, game.gameId))) }));
}
